export const DEFAULT_EARNINGS_CONTENT_LENGTH = 5;
export const EARNINGS_CONTENT_PER_PAGE_LENGTH = 15;
export const EARNINGS_CONTENT_UNLIMIT_LENGTH = Number.MAX_VALUE;
